<button class="hc-btn primary" (click)="handleReturn()">
    <icon name="back_arrow"></icon>
    RETURN
</button>